export default __webpack_public_path__ + "static/media/logo.212c3197.svg";